import EventBar from './EventBar';
import MonthBar from './MonthBar';

export default {
  components: {
    EventBar,
    MonthBar
  }
};
